export { color, rgba } from './colors';
export { reduceMotion } from './reduce-motion';
export { rtl } from './rtl';
export { space } from './space';
export { font } from './font';
export { breakpoint } from './breakpoint';
export { config } from './config';
//# sourceMappingURL=style-mixins.js.map